//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

// 销售发票查询
// const saleInvoiceList = (r) =>
//   require.ensure(
//     [],
//     () => r(require('@/pages/financeCenter/saleInvoice/list.vue')),
//     'saleInvoiceList'
//   );
// 销售发票新建
// const saleInvoiceAdd = (r) =>
//   require.ensure(
//     [],
//     () => r(require('@/pages/financeCenter/saleInvoice/add.vue')),
//     'saleInvoiceAdd'
//   );
const saleInvoiceEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/financeCenter/saleInvoice/edit.vue')),
    'saleInvoiceEdit'
  );
// const saleInvoiceDetail = (r) =>
//   require.ensure(
//     [],
//     () => r(require('@/pages/financeCenter/saleInvoice/detail.vue')),
//     'saleInvoiceDetail'
//   );

const saleInvoiceRouter = {
  path: '/saleInvoice',
  component: index,
  children: [
    {
      path: 'list',
      name: 'saleInvoiceList',
      component: () => import('@/pages/financeCenter/saleInvoice/index.vue'),
      meta: {
        keepAlive: true,
        title: '销售发票查询',
      },
    },
    // 物贸
    {
      path: 'add',
      name: 'saleInvoiceAdd',
      component: () => import('@/pages/financeCenter/saleInvoice/add.vue'),
      meta: {
        keepAlive: true,
        title: '创建销售发票',
      },
    },
    {
      path: 'edit',
      name: 'saleInvoiceEdit',
      component: saleInvoiceEdit,
      meta: {
        keepAlive: true,
        title: '销售发票修改',
      },
    },
    {
      path: 'detail',
      name: 'saleInvoiceDetail',
      component: () => import('@/pages/financeCenter/saleInvoice/detail.vue'),
      meta: {
        keepAlive: true,
        title: '销售发票详情',
      },
    },
    // 城矿
    {
      path: 'addCK',
      name: 'saleInvoiceAddCK',
      component: () => import('@/pages/financeCenter/saleInvoice/chengkuang/add.vue'),
      meta: {
        keepAlive: true,
        title: '创建销售发票',
      },
    },
    {
      path: 'editCK',
      name: 'saleInvoiceEditCK',
      component: () => import('@/pages/financeCenter/saleInvoice/chengkuang/edit.vue'),
      meta: {
        keepAlive: true,
        title: '销售发票修改',
      },
    },
    {
      path: 'detailCK',
      name: 'saleInvoiceDetailCK',
      component: () => import('@/pages/financeCenter/saleInvoice/chengkuang/detail.vue'),
      meta: {
        keepAlive: true,
        title: '销售发票详情',
      },
    },
  ],
};
export default saleInvoiceRouter;
